import * as React from 'react'
import { MdErrors } from '../widgets'
import { translate } from 'react-translate'

const successView = (text: any) => (
  <div className="inline-status order-success">
    <div>{text}</div>
  </div>
)

const errorBoxStyle = {
  marginTop: '20px'
}
class FeesConfirmation extends React.Component<any, any> {
  render() {
    let t = this.props.t
    return (
      <div>
        {this.props.showSuccess ? successView(t('UPDATE_SUCCESS')) : (<div className="confirm-view" style={{ width: '100%', marginTop: '20px' }}>
          <section className='general-container confirmation'>
            <h2 style={{padding: '0px', fontSize: '20px', margin: '0px', marginTop: '-5px'}}>{t('HEADER')}</h2>
            <fieldset>
              <legend style={{marginBottom: '10px'}}>{t('CONFIRM_BODY_TEXT')}</legend>
              <a
                style={{ width: 'calc(50% - 6px)' }}
                className="button checkmark"
                onClick={this.props.handleConfirm}
              >{t('CONFIRM_FEES_BTN')}</a>
              <a style={
                {
                  width: 'calc(50% - 6px)',
                  textAlign: 'center'
                }} className="button outline" onClick={this.props.handleCancel}>{t('CANCEL_FEES_BTN')}</a>
            </fieldset>

            <div>
              {
                this.props.errors.length > 0 ? 
                  <MdErrors style={errorBoxStyle} errors={this.props.errors} /> : null
              }
            </div>
          </section>
        </div>)}
      </div>
    )
  }
}

export default translate('FeesConfirmation')(FeesConfirmation)



// WEBPACK FOOTER //
// ./react/components/presentations/FeesConfirmation.tsx